import axios from 'axios'
import * as utils from './apiUtils'

export default {
  index(obj) {
    return axios.get(utils.getApiUrl('/emergency_inspect_reports'), {
      params: obj || {}
    })
  },
  create({ data }) {
    return axios.post(utils.getApiUrl('/emergency_inspect_reports'), data)
  },
  show({ id }) {
    return axios.get(utils.getApiUrl(`/emergency_inspect_reports/${id}`))
  },
  update({ id, data }) {
    return axios.put(utils.getApiUrl(`/emergency_inspect_reports/${id}`), data)
  },
  delete({ id }) {
    return axios.delete(utils.getApiUrl(`/emergency_inspect_reports/${id}`))
  },
  addPhotos({ id, formData }) {
    return axios.post(utils.getApiUrl(`/emergency_inspect_reports/${id}/photos`), formData)
  },
  updatePhotos({ id, data }) {
    return axios.patch(utils.getApiUrl(`/emergency_inspect_reports/${id}/photos`), data)
  },
  deletePhoto({ id, photo }) {
    return axios.delete(utils.getApiUrl(`/emergency_inspect_reports/${id}/photos/${photo.id}`))
  },
  updateAudioInput({ id, data }) {
    return axios.put(utils.getApiUrl(`/emergency_inspect_reports/${id}/audio_input`), data)
  },
  downloadCSV({ data }) {
    return axios.get('/emergency_inspect_reports/download_csv.csv', {
      params: data,
      responseType: 'blob',
    })
  },
}
